import { render, staticRenderFns } from "./MailEventList.vue?vue&type=template&id=32f0239e"
import script from "./MailEventList.vue?vue&type=script&lang=js"
export * from "./MailEventList.vue?vue&type=script&lang=js"
import style0 from "./MailEventList.vue?vue&type=style&index=0&id=32f0239e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports